import styles from './LeadersModal.module.css';
import { cx } from '@libs/classnames';
import { ModalCard } from '@ui/components/ModalCard';
import { ReactNode } from 'react';

type Props = {
  tabs: ReactNode;
  search: ReactNode;
  list: ReactNode;
  onClose: () => void;
  listLoader?: ReactNode;
  showMore?: ReactNode;
};

export function LeadersModal({
  tabs,
  search,
  list,
  onClose,
  listLoader,
  showMore,
}: Props) {
  return (
    <ModalCard
      className={cx(styles.root, 'theme-light')}
      contentClassName={styles.content}
      title="Лидеры Гран-при РШШ"
      onClose={onClose}
    >
      <div className={styles.header}>
        {tabs}
        <div className={styles.search}>{search}</div>
      </div>
      <div className={styles.list}>
        <div className={styles.listInner}>
          {list}
          {listLoader && <div className={styles.listLoader}>{listLoader}</div>}
          {showMore && <div className={styles.showMore}>{showMore}</div>}
        </div>
      </div>
    </ModalCard>
  );
}
